
import * as Data from "@/../src-gen/data";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FGompaUserRemoteAutoCompleteFieldMDP from "@/components/form/field/FGompaUserRemoteAutoCompleteMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";


export default class ExceptionFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  constructor({ taskRoot, parent }: { taskRoot: any; parent: any }) {
    super({
      myRefName: "exceptionFFormRef",
      disabled: taskRoot.taskDisabled,
    });
    this.taskRoot = taskRoot;
    this.parent = parent;

    this
    // .addField(
    //   new FSwitchMDP({
    //     parentMDP: this.childMDP,
    //     dataSelectorKey: "taskOutput.haveException",
    //     label: "Have Exception",
    //     boundaryClass: "col-12",
    //   })
    // )
    .addField(
      new FSelectFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "taskOutput.haveException",
        label: "Have Exception",
        boundaryClass: "col-4",
        options: ["YES", "NO"],
        mandatory: true
      })
    )
    .addField(new FSelectFieldMDP({
      dataSelectorKey: "taskOutput.exceptionTakenList",
      label: "Exception Taken",
      options: Data.ClientFile.EXCEPTION_TAKEN.list().filter(item => item.id !== "NO"),
      optionLabel: "name",
      optionValue: "id",
      parentMDP: this.childMDP,
      multiple: true,
      boundaryClass: "col-4",
      condition: this.taskRoot.taskFormData.taskOutput.haveException === "YES",
      mandatory: true
    })).addField(new FGompaUserRemoteAutoCompleteFieldMDP({
      parentMDP: this.childMDP,
      dataSelectorKey: "taskOutput.exceptionApprovedBy",
      label:"Exception ApprovedBy",
      boundaryClass: "col-4",
      condition: this.taskRoot.taskFormData.taskOutput.haveException === "YES",
      mandatory: true,
      minSearchValueLength: 0
    }))
  }

  getMyRef(): any {
    return this.parent.getMyRef().$refs[this.myRefName][0];
  }


}
